import { Location } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, RendererFactory2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { isNullOrUndefined } from 'is-what';
import { LineGraphReadingsDataDto } from '../../../data/models/line-graph-data-dto';
import { LineGraphSimpleDataDto } from '../../../data/models/line-graph-simple-data-dto';
import { CommonGlobalService } from '../../../services/common-global.service';
import { LineGraphService } from '../../../services/line-graph.service';
import { type } from 'os';

@Component({
  selector: 'app-traffic-graph',
  templateUrl: './traffic-graph.component.html',
  styleUrls: ['./traffic-graph.component.scss'],
  providers: [MessageService]
})
export class TrafficGraphComponent implements OnInit, AfterViewInit {
  @Input() lineName: string;

  chart: any = {};
  chartOptions: any;

  iterator: number;
  currentLineIdParameter: number;

  fromDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));
  toDate: Date = new Date();

  mainResultList: LineGraphSimpleDataDto[] = [];
  resultList: LineGraphSimpleDataDto[] = [];
  readingList: LineGraphReadingsDataDto;
  graphsReturnBasicData: any[] = [];
  blockUI: boolean = false;
  isTotal: string;
  services: any[] = [];
  selectedServices: any[] = [];
  selectedServiceindex: number;

  inTraffic: any[] = [];
  outTraffic: any[] = [];
  readingsTime: any[] = [];

  //graphStatistics: GraphReadingStatisticsDto;
  items: MenuItem[] = [];
  Headerline_graph3: string;
  openStatisticsDialog: boolean = false;
  showNoGraph: boolean = false;
  showGraph: boolean = false;
  statsGraph: string;
  currentSelectedGraph: LineGraphSimpleDataDto;
  //render: Renderer2;
  //rendererFactory: RendererFactory2
  //@ViewChild('panel', { static: true }) panel: OverlayPanel;
  //@ViewChild('elm', { static: true }) elm: ElementRef;

  chartDataList: any[] =[];
  chartCounter = 0;
  @ViewChild('chartContainer', { static: false }) chartContainer: ElementRef;

  notExist: boolean = false;

  constructor(private graphService: LineGraphService, private messageService: MessageService,
    private activatedRoute: ActivatedRoute/*, private rendererFactory: RendererFactory2*/
    , private location: Location
    , private commonGlobalService: CommonGlobalService) {
    //this.render = this.rendererFactory.createRenderer(null, null);
    //let interfacsesIds = [28033];

  }

  async ngAfterViewInit() {
    //get list of graphs
    await  this.getLineGraphListData(this.currentLineIdParameter);
    if (this.resultList.length>0) {
    }
    }




  ngOnInit() {
    //check if there is an id in url
    this.lineName = this.commonGlobalService.lineName;

     this.checkUrlParameter();
    this.items = [
      { label: 'Home', routerLink: '/' },
      { label: 'Line Details', routerLink: '/linedetails/' + this.currentLineIdParameter },
      { label: 'Line Traffic Graphs' },

    ]


  }
  checkUrlParameter() {
    this.blockUI = true;
    this.activatedRoute.params.subscribe(
      async (params) => {
        this.isTotal = params["isTotal"];
        this.currentLineIdParameter = params["id"];
        if (!this.currentLineIdParameter) {
          this.messageService.add({ severity: 'error', summary: 'Get Graph Data', detail: 'sorry could not return data of the graph' })
          return;
        }

      //  else
      //   this.getLineGraphListData(this.currentLineIdParameter);
      })

  }

  //this.fromDate, this.toDate params to get data
  async getLineGraphListData(lineId) {
    this.blockUI = true;
    this.graphService.getLineGraphListData(lineId, this.isTotal).subscribe(async (res: LineGraphSimpleDataDto[]) => {

      if (res.length > 0) {// || !isNullOrUndefined(res[0]?.interfaceId)) {

        this.mainResultList = this.resultList = res;
        this.services = [];
        this.selectedServices = [];
        this.graphsReturnBasicData = [];

        this.resultList.forEach(ss => {
          this.graphsReturnBasicData.push({ graphName: ss.graphName });
          if (this.services.filter(x => x.serviceId == ss.serviceId).length == 0) {
            this.services.push({ serviceId: ss.serviceId, serviceName: ss.serviceName });
          }
        });
        this.services.map((item) => this.selectedServices.push(item));
        this.blockUI = false;
        this.drawAllTheGraphsAtOnce(this.resultList);
        //await this.drawChart(new LineGraphReadingsDataDto);
        this.notExist = false;
      }
      else {
        this.blockUI = false;
        this.notExist = true;
        this.messageService.add({ severity: 'warn', summary: 'Get Graph List Data', detail: 'There is no Graphs for this line  ' });
      }
  
    }, (error) => {
      this.blockUI = false;
      this.messageService.add({ severity: 'error', summary: 'Get Graph List Data', detail: 'sorry could not return data of the graph now' });    })
  }





  drawLineGraph() {
    this.getLineGraphListData(this.currentLineIdParameter);
  }



  destroyChartEvent() {

    if (this.chart instanceof ApexCharts) {
      (<ApexCharts>this.chart).destroy();
    }
  
  }


  drawSelectedInterfacesGraph(graphObj: LineGraphSimpleDataDto, openPopup: boolean = false) {
    this.currentSelectedGraph = graphObj;
    this.graphService.getLineGraphDataReadings(graphObj.interfaceId, this.fromDate, this.toDate).subscribe(async (readingResult: LineGraphReadingsDataDto) => {
      this.readingList = readingResult;
      if (openPopup) {
        this.showGraph = true;
      }
      else {
        await this.drawChart(graphObj, readingResult)
      }
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Get Graph Readings Data', detail: 'sorry could not return Readings of the graph now' })
    })
  }





  drawAllTheGraphsAtOnce(graphList: LineGraphSimpleDataDto[]) {

    graphList.forEach( async g => {
       await this.drawSelectedInterfacesGraph(g);
    });
    this.chartCounter = 0;
  }



  async drawChart(graph: LineGraphSimpleDataDto , upDownData: LineGraphReadingsDataDto) {

    let x: any = this.GetTrafficData(upDownData);
    this.destroyChartEvent();
    const char = {
      series: [{
        name: 'OutTraffic',
        data: x.__zone_symbol__value.outTraffic //this.outTraffic ////
      },
      {
        name: 'Intraffic',
        data: x.__zone_symbol__value.inTraffic //this.inTraffic //  //
      }],
      chart: {
        height: 350,
        type: "line",
      },
      colors: ['#068DA9', 'lightgreen'],
      dataLabels: {
        enabled: false
      },
      title: {
        text: graph.graphName
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      tooltip: {
        x: {
          show: true,
          format: 'dd MMM yyyy  HH:mm',
          formatter: undefined,
        },
        y: {
          title: {
            formatter: function (value1, value2) {
              return;
            }
          }

        },
        shared: false
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
        },
        categories: x.__zone_symbol__value.readingTime
      },
      yaxis: {
        labels: {

          formatter: function (value, index) {
            var val = Math.abs(value);
            if (val >= 1000000000) {
              value = (value / 1000000000).toFixed(1) + " Gps";
            }
            else if (val >= 1000000) {
              value = (value / 1000000).toFixed(1) + " Mps";
            }
            else if (val >= 1000 && val < 1000000) {
              value = (value / 1000).toFixed(1) + " Kps";
            }

            else if (val < 1000) {
              value = value + " bps";
            }
            return value;
          }
        }
      },
      toolbar: {
        show: true,

      },
      noData: {
        text: 'No Data Found',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
      }
    };

    const container = document.getElementById('chartContainer');

    const childContainer = document.createElement('div');
    childContainer.className = 'row';

    const chartElement = document.createElement('div');
    chartElement.id = 'chart-' + this.chartCounter;
    chartElement.className = 'col-md-11 col-sm-11';

    const btnElement = document.createElement('button');
    btnElement.classList.add('rounded-circle');
    btnElement.classList.add('border-0');
    btnElement.style.backgroundColor = 'darkorange';
    btnElement.innerHTML = '<i class="fa fa-chart-line"></i> ';
    btnElement.addEventListener("click", () => { this.drawSelectedInterfacesGraph(graph,true) }, false);

    const btnContainer = document.createElement('div');
    btnContainer.className = 'col-md-1 col-sm-1';
    btnContainer.appendChild(btnElement);

    childContainer.appendChild(chartElement);
    childContainer.appendChild(btnContainer);

    container.appendChild(childContainer);

    this.chartCounter++;

 
    const chartOption = char;
    const chartInstance = new ApexCharts(document.getElementById('chart-' +(this.chartCounter-1)), chartOption);
    chartInstance.render();

    this.blockUI = false;
  }


  async GetTrafficData(upDownData: LineGraphReadingsDataDto) {
    this.inTraffic = [];
    this.outTraffic = [];
    this.readingsTime = [];

    for (var i = 0; i < upDownData.readings?.length; i++) {
      this.readingsTime.push((upDownData.readings[i].readingTime));
      this.inTraffic.push((upDownData.readings[i].inTraffic));
      this.outTraffic.push((upDownData.readings[i].outTraffic));
    }
    if (upDownData?.readings?.length == 0) {
      this.inTraffic.push[0];
      this.outTraffic.push[0];
      this.readingsTime.push(this.toDate);

    }
    this.readingsTime.push(new Date(new Date().setHours(new Date().getHours() + 1))); //exceed to one hour to have a clear line 
    let inOutData = { inTraffic: this.inTraffic, outTraffic: this.outTraffic, readingTime: this.readingsTime };
    return inOutData;
  }


}







